import { useQuery, useQueryClient } from "@tanstack/react-query";
import collectionApiClient, {
  PopulatedCollection,
} from "../../../api/collection";

const useCollection = (collectionId?: string) => {
  const queryClient = useQueryClient();
  return useQuery<PopulatedCollection>({
    queryKey: ["collection", collectionId],
    queryFn: async () => {
      const collection = await collectionApiClient.getCollectionById(
        collectionId!,
      );
      if (collection.klydos) {
        for (const klydo of collection.klydos) {
          queryClient.setQueryData(["klydo", klydo.id], klydo);
        }
      }
      return collection;
    },
    enabled: !!collectionId,
  });
};

export default useCollection;
